<div class="form-group py-1" style="user-select: none;">
  <div style='overflow-x: hidden;'>
    <table class="table table-responsive table-striped border">
      <thead>
        <tr>
          <th scope="col">User</th>
          <th scope="col">Email</th>
          <th scope="col">Permission</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        @for (permission of permissions; track permission; let i = $index) {
          <tr style="position: relative;">
            <td style="vertical-align: middle;">{{permission.user.name}}</td>
            <td style="vertical-align: middle;">{{permission.user.email}}</td>
            <!-- Edit users permissions -->
            @if (currentUserPermission == 'Owner') {
              <td>
                <select class="form-select form-select-sm"
                  (change)="showUpdateConfirmation(permission, $event.target)" style="cursor: pointer;">
                  <option value="Viewer" [selected]="permission.permission == 'Viewer'">
                    Viewer
                  </option>
                  <option value="Editor" [selected]="permission.permission == 'Editor'">
                    Editor
                  </option>
                  <option value="Owner" [selected]="permission.permission == 'Owner'">
                    Owner
                  </option>
                </select>
              </td>
            }
            <!-- Display users permissions -->
            @if (currentUserPermission != 'Owner') {
              <td style="vertical-align: middle">
                {{permission.permission}}
              </td>
            }
            <!-- Info and Trash Buttons -->
            <td style="vertical-align: middle;">
              <div class='d-flex'>
                <!-- Info (i) Icon in the Details page -->
                                <a class="btn btn-sm" data-bs-toggle="tooltip" title='
                                <div class="d-flex flex-column">
                                    <span class="me-1">Last Edited: {{permission?.lastEdited | date }}</span>
                                    <span>Last Accessed: {{permission?.lastAccessed | date}}</span>
                                </div>' data-bs-html="true" style="cursor: default;">
                                    <i class="permission-action fa-solid fa-info-circle"></i>
                                </a>

                                <!-- Delete Permission trash button -->
                                @if (currentUserPermission == "Owner" || currentUser?.id == permission.userID) {
<a
                                    class="btn btn-sm" (click)="showDeleteConfirmation(permission)">
                                    <i class="fa fa-trash" [ngClass]="{
                                        'permission-action': permissionChanges?.permission?.userID != permission.userID, 
                      'permission-action-delete': permissionChanges?.permission?.userID == permission.userID && editPermissionsState == 'delete'
                    }"></i>
                  </a>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @switch (editPermissionsState$ | async) {
    @case ('update') {
      <div class='p-1 d-flex flex-wrap border justify-content-between align-items-center'
        [style.backgroundColor]="'rgba(252, 255, 187, 0.577)'">
        <span class="text-center flex-grow-1 me-auto text-warning">{{message}}</span>
        <div class='flex-grow-1 text-center'>
          <button class="me-1 btn btn-sm btn-warning text-white" (click)='confirmUpdate()'>
            Update
          </button>
          <button class='btn btn-sm btn-secondary' (click)='cancel()'>Cancel</button>
        </div>
      </div>
    }
    @case ('delete') {
      <div class='p-1 d-flex flex-wrap border justify-content-between align-items-center'
        [style.backgroundColor]="'rgba(255, 187, 187, 0.577)'">
        <span class="text-center flex-grow-1 me-auto text-danger">{{message}}</span>
        <div class='flex-grow-1 text-center'>
          <button class="me-1 btn btn-sm btn-danger" (click)='confirmDelete()'>
            Delete
          </button>
          <button class='btn btn-sm btn-secondary' (click)='cancel()'>Cancel</button>
        </div>
      </div>
    }
    @case ('oneUserWarning') {
      <div id='oneOwnerWarning' class='p-1 d-flex border align-items-center'
        style='background-color: rgba(252, 255, 187, 0.577);'>
        <span class='text-warning text-center flex-grow-1 me-auto'>{{message}}</span>
        <button class='btn btn-sm btn-close' (click)='cancel()'></button>
      </div>
    }
    @case ('add') {
      <shared-create-permission (onCreate)='permissionAdded()'>
      </shared-create-permission>
    }
    @default {
      @if (currentUserPermission == 'Owner' && !inFreeTier) {
        <div class="row pt-2 pe-3">
          <div class="col-auto ms-auto">
            <a class="btn btn-sm btn-success" [ngClass]="{'disabled': inFreeTier}" (click)="addPermission()">
              <i class="fas fa-plus fa-fw"></i>
            </a>
            @if (inFreeTier) {
              <i class="ms-1 text-secondary fas fa-lock fa-fw"></i>
            }
          </div>
        </div>
      }
    }
  }
</div>